import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Dialog, LoadingButton } from '@myn/mui';

import { useInsertionOrderApi } from '../../hooks/useInsertionOrderApi.js';
import { useInsertionOrderModal } from '../../hooks/useInsertionOrderModal.js';
import { getModalContent } from '../../utils/insertionOrder.jsx';

const InsertionOrderModal = () => {
  const { t } = useTranslation('@myn/planning');

  const { modalData, closeModal } = useInsertionOrderModal();

  const [isLoading, setIsLoading] = useState(false);

  const { isOpen, data, type } = modalData;

  const { buyingPlanId, buyingPlanItemId } = data || {};

  const [selectedInsertionOrder, setSelectedInsertionOrder] = useState<
    number | null | undefined
  >();
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const listType = type === 'list' || type === 'list_with_new';

  const submitButtonIsDisabled =
    !selectedInsertionOrder && selectedInsertionOrder !== null && listType;

  const { handleInsertionOrderEntryCreation } = useInsertionOrderApi();

  const selectInsertionOrder = (itemId?: number | null) => {
    setSelectedInsertionOrder(itemId);
  };

  const toggleDoNotShowAgain = () => {
    setDoNotShowAgain(!doNotShowAgain);
  };

  const { title, content } = getModalContent({
    t,
    data,
    type,
    selectInsertionOrder,
    toggleDoNotShowAgain,
  });

  const handleResetData = () => {
    setIsLoading(false);
    closeModal();
  };

  const submitFn = async (ioId?: number | null) => {
    if (!buyingPlanId || !buyingPlanItemId) {
      return;
    }

    setIsLoading(true);

    const dataForCreation = {
      ioId,
      buyingPlanId,
      buyingPlanItemId,
    };

    await handleInsertionOrderEntryCreation(dataForCreation);

    handleResetData();
  };

  const handleSubmitForPlatformLevel = async () => {
    await submitFn(selectedInsertionOrder);
  };

  const handleSubmitForMediaRowLevel = async () => {
    if (doNotShowAgain) {
      localStorage.setItem(type, 'hidden');
    }

    await submitFn(data?.ioData[0]?.ioId);
  };

  const handleSubmit = () => {
    if (type === 'list' || type === 'list_with_new') {
      handleSubmitForPlatformLevel();
      return;
    }

    handleSubmitForMediaRowLevel();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      title={title}
      submitButton={
        <LoadingButton
          size="large"
          variant="contained"
          loading={isLoading}
          onClick={handleSubmit}
          disabled={submitButtonIsDisabled}
        >
          {t('Proceed')}
        </LoadingButton>
      }
      cancelButtonProps={{
        label: t('Cancel'),
        onClick: closeModal,
      }}
    >
      {content}
    </Dialog>
  );
};

export default InsertionOrderModal;
